/**
 * Returns true if preview data is available in the FlexibleUiDataContext
 * @param context is the FlexibleUiDataContext
 */
export var isFlexUiPreviewPresent = function isFlexUiPreviewPresent(context) {
  return Boolean(context && context.preview);
};